
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class DateRangePicker extends Vue {
  @Prop({ default: false })
  compact!: boolean;

  @Prop({ default: () => new Date() })
  maxDate!: Date | null;

  @Prop({ default: () => new Date("2022-01-01T11:03:19.321Z") }) // there should never be any log entry for a time where this product didn't exist yet ^^
  minDate!: Date | null;

  @Prop({
    default: () => [moment().subtract(7, "day").toDate(), moment().toDate()],
  })
  initialRange!: [Date, Date] | [Date];

  dateRange: string[] = [];
  suppressNextInput = false;

  mounted(): void {
    this.syncInitialRange();
  }

  get maxBound(): string | undefined {
    return this.maxDate ? this.formatPickerDate(this.maxDate) : undefined;
  }

  get minBound(): string | undefined {
    return this.minDate ? this.formatPickerDate(this.minDate) : undefined;
  }

  get sortedDateRange(): Date[] {
    return this.dateRange
      .map((value) => moment(value, "YYYY-MM-DD", true).toDate())
      .filter((date) => !Number.isNaN(date.getTime()))
      .sort((d1, d2) => d1.getTime() - d2.getTime());
  }

  @Watch("dateRange", { deep: true })
  onDateRangeChanged(): void {
    if (this.suppressNextInput) {
      this.suppressNextInput = false;
      return;
    }

    if (this.sortedDateRange.length !== 2) {
      return;
    }

    this.$emit("input", [
      moment(this.sortedDateRange[0]).startOf("day").toDate(),
      moment(this.sortedDateRange[1]).endOf("day").toDate()
    ] as [Date, Date]);
  }

  @Watch("initialRange", { deep: true })
  onInitialRangeChanged(): void {
    this.syncInitialRange();
  }

  private syncInitialRange(): void {
    const nextRange = this.initialRange.map((date) =>
      this.formatPickerDate(date)
    );

    if (JSON.stringify(this.dateRange) === JSON.stringify(nextRange)) {
      return;
    }

    this.suppressNextInput = true;
    this.dateRange = nextRange;
  }

  private formatPickerDate (date: Date): string {
    return moment(date).format("YYYY-MM-DD");
  }

  get dateRangeText(): string {
    if (!this.sortedDateRange.length) {
      return "";
    }

    return `${this.sortedDateRange[0].toLocaleDateString()} - ${
      this.sortedDateRange[1]
        ? this.sortedDateRange[1].toLocaleDateString()
        : ""
    }`;
  }
}
